(function() {
	var app = angular
		.module('trackeye', [
			'ngResource',
			'ngSanitize',
			'pascalprecht.translate',
			'ngAnimate',
			'ngMessages',
			'ui.router',
			'ngStorage',
			'angular-cache',
			'angularResizable',
			'angularMoment',
			'ngCsv',
			'ui.select'
		]);

	var	injector 	= angular.injector(["ng"]),
		$http 		= injector.get("$http");

	$http.get("/api/initialize").then(function(resp) {
		bootstrap(resp.data, app);
	});
})();

function bootstrap (config, app) {
	app.constant('config', config);
	app.config(AppConfig);

	AppConfig.$inject = ['$urlMatcherFactoryProvider', '$qProvider', '$httpProvider', 'CacheFactoryProvider', '$translateProvider', 'uiSelectConfig'];

	function AppConfig($urlMatcherFactoryProvider, $qProvider, $httpProvider, CacheFactoryProvider, $translateProvider, uiSelectConfig) {
		// $qProvider.errorOnUnhandledRejections(false);
		$urlMatcherFactoryProvider.strictMode(false);
		$httpProvider.interceptors.push('TokenInjector', 'LanguageInjector', 'TokenRefresher', 'JsonInterceptor', 'PartialsCacheBuster', 'ResponseRewriter');
		angular.extend(CacheFactoryProvider.defaults, {maxAge: 15 * 60 * 1000});

		$translateProvider
			.useSanitizeValueStrategy('escapeParameters')
			.useStaticFilesLoader({
				prefix: 'lang/locale.',
				suffix: '.json'
			})
			.preferredLanguage('en')
			.fallbackLanguage('en');

		uiSelectConfig.theme = 'select2';
		uiSelectConfig.appendToBody = true;
	}

	angular.element(document).ready(function() {
		angular.bootstrap(document, ['trackeye']);
	});
}
